<div class="main-nav">
  <mat-nav-list *ngIf="navLinks" (click)="onCloseSidenav()">
    <mat-accordion>
      <ul [ngSwitch]="pathUrl">
        <ng-container *ngFor="let item of navLinksApp">
          <li [routerLink]="[item.route]" routerLinkActive="router-link-active" *ngIf="!isAdmin "> {{item.name}}</li>
          <li [routerLink]="[item.route]" routerLinkActive="router-link-active" *ngIf="isAdmin"> {{item.name}}</li>
        </ng-container>
      </ul>
      <!-- <app-nav-item *ngFor=" let link of navLinks" [link]="link">
          </app-nav-item> -->
    </mat-accordion>
  </mat-nav-list>

  <mat-list>
    <mat-list-item>
      <span class="white">Developped by</span>
    </mat-list-item>
    <mat-list-item>
      <a href="https://www.bizzdev.com/" target="_blank">
        <img src="/assets/icons/bizzdev_w.png" alt="Logo Bizzdev" width="44" height="28">
      </a>
      <!-- <a href="https://www.phoenix-ai.com/" target=" _blank">
        <img src="/assets/icons/Phoenix.png" alt="Logo Phoenix" width="44" height="44">
      </a> -->
      <span class="white">
        version: {{appVersion}}
      </span>
    </mat-list-item>
    <mat-list-item *ngIf="isLocalTranslations" class="local-translation">
      <span class="white">- Local Translations: ON -</span>
    </mat-list-item>
  </mat-list>
</div>